<template>
  <div class="Man-JuridicoPrincipal">
    <PageTitle icon="fa fa-shopping" main="Controle de processo" sub=" " />
    <div class="Man-JuridicoPrincipal">
      <b-card no-body>
        <b-tabs
          nav-wrapper-class="tabs-verde"
          active-nav-item-class="aba-ativa"
        >
          <b-tab title="Processo" active><JuridicoProcessoLancamento /></b-tab>
          <b-tab title="Audiência"><JuridicoProcessoAudiencia /></b-tab>
          <b-tab title="Financeiro"><JuridicoProcessoFinanceiro /></b-tab>
          <b-tab title="Indicadores"><JuridicoProcessoPainel /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import JuridicoProcessoLancamento from "../juridico/JuridicoProcessoLancamento";
import JuridicoProcessoAudiencia from "../juridico/JuridicoProcessoAudiencia";
import JuridicoProcessoFinanceiro from "../juridico/JuridicoProcessoFinanceiro";
import JuridicoProcessoPainel from "../juridico/JuridicoProcessoPainel";

export default {
  name: "JuridicoPrincipal",
  components: {
    PageTitle,
    JuridicoProcessoLancamento,
    JuridicoProcessoPainel,
    JuridicoProcessoAudiencia,
    JuridicoProcessoFinanceiro,
  },
};
</script>

<!-- 🔥 CSS ajustado com classe personalizada -->
<style>
.tabs-verde .nav-link.aba-ativa {
  background-color: #28a745 !important;
  color: white !important;
  border-color: #28a745 !important;
}

.tabs-verde .nav-link:focus {
  box-shadow: none;
}
</style>
